<template>
  <w-settings-detail :title="title" :menu="menu" default-active-menu="WAppLogSetting" @change="onChangeMenu">
    <component slot="activeView" :is="currentView"></component>
  </w-settings-detail>
</template>

<script>
import WSettingsDetail from '@/components/template/SettingsDetail';
import WAppLogSetting from '../Applog';
import WSysLogSetting from '../Syslog';
import WSnmpTrapSetting from '../SnmpTrap';
import WLogManagementSetting from '../log-management';
import WVirtualLogSetting from '../Virtuallog';

export default {
  name: 'WCollectionSettings',
  components: {
    WAppLogSetting,
    WSettingsDetail,
    WSysLogSetting,
    WSnmpTrapSetting,
    WLogManagementSetting,
    WVirtualLogSetting,
  },
  props: {
    title: String,
  },
  data() {
    return {
      currentView: 'WAppLogSetting',
      logSettingLists: [
        { value: 'WAppLogSetting', label: 'Application Log' },
      ],
      menu: [
        {
          id: 'WAppLogSetting',
          name: '어플리케이션 로그',
          active: true,
        },
        {
          id: 'WSysLogSetting',
          name: '시스템 로그',
          active: false,
        },
        {
          id: 'WSnmpTrapSetting',
          name: 'SNMP Trap',
          active: false,
        },
        {
          id: 'WVirtualLogSetting',
          name: '가상화 로그',
          active: false,
        },
        {
          id: 'WLogManagementSetting',
          name: '로그 관리 설정',
          active: false,
        },
      ],
    };
  },
  methods: {
    onChangeMenu(data) {
      this.currentView = data;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/log/components/index.vue